import "./stats.scss";
import StatsCard, {IStatsCard} from "./statscard/statscard";
import Range from "../range/range";
import * as React from "react";
import Button from "../../core/button/button";
import {StatsChart} from "../chart/stats/statschart";

const Stats = () => {
    const statsCard: IStatsCard[] = [
        {
            type: "dark",
            title: "تبلیغ در گوگل",
            desc: "این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند."
        },
        {
            type: "dark",
            title: "تبلیغات همسان",
            desc: "این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند."
        },
        {
            type: "gray",
            title: "تبلیغات بنری",
            desc: "این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند."
        },
        {
            type: "light",
            title: "تبلیغات ویدئويي",
            desc: "این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند."
        },
        {
            type: "gray",
            title: "تیزر استانی",
            desc: "این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند."
        },
        {
            type: "gray",
            title: "شبکه های اجتماعی",
            desc: "این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند."
        },
        {
            type: "gray",
            title: "رپورتاژ آگهی",
            desc: "این متن برای توضیحات مربوط به دانلود اپلیکیشن است که کاربر را راهنمایی کند."
        },
    ]
    return (
        <div className="Stats">
            <p className="Title">
                رسانه‌های پیشنهادی تی‌جار بر اساس هدف شما از تبلیغات:
            </p>
            <p className="Subtitle pb-4">
                از میان رسانه‌های مختلف تی‌جار ۵ رسانه مناسب شما انتخاب شده است که میتوانید به دلخواه اضافه یا کم
                نمایید.
            </p>
            <div className="row d-flex justify-content-center align-items-center">
                {
                    statsCard.map((statCard, index) => {
                        return (
                            <div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-5">
                                <StatsCard key={index} type={statCard.type} title={statCard.title}
                                           desc={statCard.desc}/>
                            </div>
                        )
                    })
                }
            </div>
            <p className="Title">
                بودجه کلی در نظر گرفته شده شما برای این کمپین :
            </p>
            <p className="Subtitle pb-2">
                بودجه انتخابی برای کل کمپین بوده و در بین رسانه های مختلف انتخابی ( و یا پیشنهاد شده) تقسیم خواهد شد.
            </p>
            <p className="Title">
                بودجه پیشنهادی تیجار برای رسانه های مختلف :
            </p>
            <div className="row">
                <div className="col-lg-6 col-12">
                    <div className="Budget-Amount mb-3">50،000،000 تومان</div>
                    <span style={{fontWeight: '500', fontSize: '14px', color: '#4865FF'}}>میلیون تومان</span>
                    <p className="Subtitle pb-4 pt-3">
                        با جا به جایی نمودار زیر میتوانید بودجه پیشنهادی تیجار را تغییر دهید.
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="Slider-Card">
                        <img src={require("../../assets/images/icons/StatsDark.svg").default} alt=""
                             className="img-fluid"/>
                        <span>تبلیغات ویدیویی</span>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <Range minValue={21} defaultValue={34}/>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="Slider-Card">
                        <img src={require("../../assets/images/icons/StatsDark.svg").default} alt=""
                             className="img-fluid"/>
                        <span>تبلیغات ویدیویی</span>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <Range minValue={49} defaultValue={90}/>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="Slider-Card">
                        <img src={require("../../assets/images/icons/StatsDark.svg").default} alt=""
                             className="img-fluid"/>
                        <span>تبلیغات ویدیویی</span>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <Range minValue={16} defaultValue={24}/>
                </div>
            </div>
            <div className="Result-Box d-flex justify-content-around align-items-center flex-wrap">
                <div>
                    <img src={require("../../assets/images/icons/Budget.svg").default} alt=""
                         className="img-fluid ps-2"/>
                    <span className="Result-Box-Title">بودجه انتخابی شما : </span>
                    <span className="Result-Box-Result">120,000 میلیون</span>
                </div>
                <div>
                    <img src={require("../../assets/images/icons/Tag.svg").default} alt=""
                         className="img-fluid ps-2"/>
                    <span className="Result-Box-Title">باقیمانده : </span>
                    <span className="Result-Box-Result">150,000 میلیون</span>
                </div>
                <Button type={"secondary"} action={() => {
                }} responsive={true}>
                    <img src={require("../../assets/images/icons/Repeat.svg").default} alt=""
                         className="img-fluid ps-2"/>
                    ریست به پیشنهاد اولیه
                </Button>
            </div>
            <StatsChart/>
        </div>
    )
}

export default Stats;